import { Link } from 'react-router-dom';

const chain = ['Цель', 'Роль', 'Ответственность', 'Задача', 'Ресурсы', 'Контроль', 'Обратная связь', 'Результат'];

const conditions = [
  'цели — зачем выполняется работа и какой результат нужен;',
  'приоритеты — что важнее, когда задач несколько;',
  'зоны ответственности — кто и за что отвечает;',
  'критерии результата — как понять, что работа сделана хорошо;',
  'сроки — к какому моменту нужен результат;',
  'правила взаимодействия — как сотрудники работают друг с другом;',
  'точки контроля — когда и как проверяется промежуточный результат.',
];

export default function ManagementStartsWithResult() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          Управление командой начинается с результата
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Что должен создавать руководитель, чтобы команда работала самостоятельно и на результат
        </p>

        <div className="flex flex-wrap items-center justify-center gap-2 mb-12">
          {chain.map((step, i) => (
            <div key={step} className="flex items-center gap-2">
              <span className="bg-white border border-gray-200 text-gray-800 px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap">
                {step}
              </span>
              {i < chain.length - 1 && <i className="ri-arrow-right-line text-teal-600"></i>}
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-start">
          <div className="bg-white rounded-2xl border border-gray-200 p-6 md:p-8">
            <h3 className="text-lg font-bold text-gray-900 mb-4">Задача руководителя</h3>
            <p className="text-gray-600 text-sm leading-relaxed mb-5">
              Руководитель отвечает не только за то, чтобы сотрудники «хотели работать», но и за создание условий, в которых работа организована понятно и предсказуемо.
            </p>
            <div className="space-y-2.5">
              {conditions.map((c, i) => (
                <div key={i} className="flex items-start gap-2.5">
                  <i className="ri-checkbox-circle-line text-teal-600 mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm text-gray-700 leading-relaxed">{c}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-teal-50 rounded-2xl border border-teal-200 p-6 md:p-8">
            <h3 className="text-lg font-bold text-teal-900 mb-4">Связь с постановкой задач</h3>
            <p className="text-teal-800 text-sm leading-relaxed mb-5">
              Управление результатом невозможно без умения правильно ставить задачи и передавать ответственность. Когда задача сформулирована неясно или ответственность не передана, мотивация снижается, а руководитель вынужден постоянно вмешиваться.
            </p>
            <Link
              to="/menedzhment-i-liderstvo/delegirovanie-i-postanovka-zadach"
              className="inline-flex items-center gap-2 text-sm font-semibold text-teal-700 hover:text-teal-800 transition-colors cursor-pointer"
            >
              Делегирование и постановка задач
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}